import { BREAK_POINTS_PX } from 'lib/theme';

export const isPhone = () => window.innerWidth < BREAK_POINTS_PX[0];
